module.exports = __webpack_public_path__ + "media/images/pc/no_image-482cb34967da0c907af1ad8299bd7fd5.png";